import { Fragment } from "react";
interface SectionData {
  sectionTitle: string;
  subTitleText?: string;
}

interface SectionListProps {
  data: SectionData[] | SectionData;
  className?: string;
}

const SectionList: React.FC<SectionListProps> = ({ data, className = "" }) => {
  const normalizeData = Array.isArray(data) ? data : [data];

  const processHtml = (html: string): string[] => {
    if (!html) return [];
    const withNewlines = html.replace(/<br\s*\/?>/gi, "\n");
    const cleanText = withNewlines.replace(/<[^>]+>/g, "");
    return cleanText
      .split("\n")
      .map((line) => line.trim())
      .filter((line) => line);
  };

  return (
    <div data-testid="section-list" className={`flex flex-col ${className}`}>
      {normalizeData.map((item, index) => (
        <div className="mb-3" key={`section-${item.sectionTitle}`}>
          <h3 className="mb-2 text-sm font-medium leading-6 md:mb-0">
            {item.sectionTitle}
          </h3>
          {item.subTitleText &&
            processHtml(item.subTitleText).map((line) => (
              <p key={line} className="text-[10px] leading-[16px]">
                {line}
              </p>
            ))}
        </div>
      ))}
    </div>
  );
};

export default SectionList;
